import React, { useEffect, useState } from "react";
import { Howl } from "howler";
import { toast } from "react-toastify";
import BookingToast from "./BookingToast";
import notificationSound from "../assets/audios/notify.mp3";
import bookingConfirmationSound from "../assets/audios/booking-confirmation.mp3";
import bookingCancelSound from "../assets/audios/booking-cancel.mp3";
import customerCancelSound from "../assets/audios/customer-cancel.mp3";
import Authorization from "../utility/authorization";

const BookingToaster = ({ data, eventType, history, closeToast }) => {
  const [authUser, setAuthUser] = useState(null);

  useEffect(() => {
    // Check if getAuthUser exists before calling it
    if (Authorization.getAuthUser) {
      const user = Authorization.getAuthUser();
      console.log("Auth User:", user); // Debugging log
      setAuthUser(user);
    }
  }, []);

  const speakText = (text) => {
    if (!text) return;
    const utterance = new SpeechSynthesisUtterance(text);
    utterance.lang = "en-US";
    utterance.rate = 1.0;
    utterance.pitch = 1.0;
    speechSynthesis.speak(utterance);
  };
  try {
    let toastType;
    let toastMessage;
    let autoClose = false;
    let progressClassName = "";
    let className = "";
    let closeButton = true;
    let closeOnClick = true;
    let soundSrc = null;

    if (eventType === "enquiries") {
      toastType = "info";
      toastMessage = (
        <BookingToast
          {...data}
          history={history}
          closeOnClick={closeOnClick}
          closeToast={closeToast}
        />
      );
      closeOnClick = false;
    } else if (eventType === "sla-breached") {
      const userName = authUser.firstName || "User";

      if (
        authUser.id !== 19 &&
        authUser.id !== 58293 &&
        authUser.id !== 191958275
      ) {
        speakText(
          `${userName}, S L A has been breached.... check the notification now.`,
        );
      }

      // soundSrc = notificationSound;
    } else if (eventType === "booking-create") {
      toastType = "success";
      toastMessage = data.message;
      autoClose = true;
      closeOnClick = false;
      soundSrc = notificationSound;
    } else if (eventType === "booking-cancel") {
      toastType = "warning";
      toastMessage = data.message;
      autoClose = true;
      closeOnClick = false;
    } else if (eventType === "booking-create-customer") {
      toastType = "success";
      toastMessage = (
        <BookingToast
          {...data}
          history={history}
          closeOnClick={closeOnClick}
          closeToast={closeToast}
        />
      );
      closeOnClick = false;
      soundSrc = notificationSound;
    } else if (eventType === "booking-cancel-customer") {
      toastType = "warning";
      toastMessage = (
        <BookingToast
          {...data}
          history={history}
          closeOnClick={closeOnClick}
          closeToast={closeToast}
        />
      );
      closeOnClick = false;
    } else if (eventType === "booking-update") {
      toastType = "warning";
      toastMessage = (
        <BookingToast
          {...data}
          closeOnClick={closeOnClick}
          closeToast={closeToast}
          history={history}
        />
      );
      progressClassName = "custom-progress-bar";
      className = "custom-toast";
      closeOnClick = false;
    } else if (eventType === "new-driver-registered") {
      toastType = "warning";
      toastMessage = (
        <BookingToast
          {...data}
          closeOnClick={closeOnClick}
          closeToast={closeToast}
          history={history}
        />
      );
      className = "driver-toast";
      closeOnClick = false;
    }

    if (eventType === "fare-requested") {
      toastType = "info";

      toastMessage = (
        <BookingToast
          {...data}
          history={history}
          closeOnClick={closeOnClick}
          closeToast={closeToast}
        />
      );

      closeOnClick = false;
      soundSrc = notificationSound;
    } else if (eventType === "booking-confirmed-agent") {
      toastType = "success";
      toastMessage = (
        <BookingToast
          {...data}
          history={history}
          userType="agent"
          closeOnClick={closeOnClick}
          closeToast={closeToast}
        />
      );

      soundSrc = bookingConfirmationSound;
    } else if (eventType === "booking-confirmed-customer") {
      toastType = "success";

      toastMessage = (
        <BookingToast
          {...data}
          history={history}
          userType="customer"
          closeOnClick={closeOnClick}
          closeToast={closeToast}
        />
      );

      soundSrc = bookingConfirmationSound;
    }
    // Play sound only for "enquiries" and "booking-term"
    if (soundSrc) {
      const sound = new Howl({
        src: [soundSrc],
        autoplay: true,
      });
      sound.play();
    }

    // Display toast only when a valid message exists
    if (toastMessage) {
      toast(toastMessage, {
        type: toastType,
        autoClose,
        progressClassName,
        className,
        closeButton,
        closeOnClick,
      });
    }

    return null;
  } catch (error) {
    console.error("Error playing audio or displaying toast:", error);
    return null;
  }
};

export default BookingToaster;
